import { Button } from '../../../components/Button';
import { ButtonGroup } from '../../../components/ButtonGroup';
import { Popup } from '../../../components/Popup';
import PopupStructure from '../../../components/PopupStructure';
import PopupTitleDangerous from '../../../components/PopupTitleDangerous';
import styles from "../StudioPage/Studio.module.css";

export interface IStudioChannelPopupDelete {
    onClose: () => void;
    isShow: boolean;
    errorMessage: string;
    onTariffChange: () => void;
  };

const StudioChannelPopupTariff = ({ isShow, onClose, errorMessage, onTariffChange }: IStudioChannelPopupDelete) => {
  return (
    <Popup isShow={isShow} onClose={onClose}>
      <PopupStructure
        headerComponent={<PopupTitleDangerous>Упс!</PopupTitleDangerous>}
        contentComponent={
          <div className={styles['page__popup-description']}>
            <p>{errorMessage}</p>
          </div>
        }
        footerComponent={
          <ButtonGroup>
            <Button kind="secondary" onClick={onClose}>Отмена</Button>
            <Button kind="primary" onClick={onTariffChange}>Сменить тариф</Button>
          </ButtonGroup>
        }
      />
    </Popup>
  );
};

export default StudioChannelPopupTariff;
